import React, { memo } from 'react';
export function ProblemSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-black mb-10" data-id="element-160">
          The problem no one says out loud
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-orange/20" data-id="element-161">
          <p className="font-sans text-xl text-gray-800 mb-8 font-medium" data-id="element-162">
            If you're a dog owner, this probably feels familiar:
          </p>

          <ul className="space-y-5 mb-10" data-id="element-163">
            {['You take lots of photos, but very few feel truly special', 'Your dog moves before you get the shot', 'You never know what angle looks best', 'Indoor photos come out dark or flat', 'Outdoor photos feel random or messy', 'You want beautiful memories, but your results feel inconsistent'].map((item, index) => <li key={index} className="flex items-start" data-id="element-164">
                <span className="text-red-500 mr-4 text-xl mt-0.5" data-id="element-165">❌</span>
                <span className="font-sans text-lg text-gray-700" data-id="element-166">{item}</span>
              </li>)}
          </ul>

          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-167">
            <p className="font-sans text-lg text-gray-800" data-id="element-168">
              And the worst part is this constant feeling of:
            </p>
            <p className="font-serif text-xl md:text-2xl font-bold text-black mt-3 italic" data-id="element-169">
              "I know my dog is adorable… I just wish I knew how to capture it
              better."
            </p>
          </div>
        </div>
      </div>
    </section>;
}